import { getEmployeeInitialsFromName } from '../../../utils/employeeInitials';
import {
  CreatedByColleagueFragment,
  EmployeeSkillAssociationFragment,
  SkillNamesFragment,
} from '../../../__generated__/graphql';
import {
  Employee,
  EmployeeSkillAssociation,
  isSkillLevel,
  Skill,
  SkillLevel,
  SkillTranslations,
} from './types';

type SkillTranslationFields = {
  flair__German__c?: string | null;
  flair__French__c?: string | null;
  flair__Italian__c?: string | null;
  flair__Spanish__c?: string | null;
  flair__Portuguese__c?: string | null;
  flair__Norwegian__c?: string | null;
  flair__Russian__c?: string | null;
};

export const mapSkillTranslations = (
  src: SkillTranslationFields,
): SkillTranslations => ({
  de: src.flair__German__c ?? null,
  fr: src.flair__French__c ?? null,
  it: src.flair__Italian__c ?? null,
  es: src.flair__Spanish__c ?? null,
  pt: src.flair__Portuguese__c ?? null,
  no: src.flair__Norwegian__c ?? null,
  ru: src.flair__Russian__c ?? null,
});

export const mapEmployee = (src: CreatedByColleagueFragment): Employee => ({
  id: src.Id,
  name: src.Name,
  initials: getEmployeeInitialsFromName(src.Name),
  avatarUrl: src.avatar?.url ?? undefined,
});

export const mapSkill = (src: SkillNamesFragment): Skill => ({
  id: src.Id,
  name: src.localizedName,
  baseName: src.Name,
  translations: mapSkillTranslations(src),
  isRateable: src.flair__Rateable__c,
  createdDate: src.CreatedDate,
  selfServiceMode: src.flair__Self_Service_Mode__c ?? null,
  category: src.category
    ? { id: src.category.Id, name: src.category.Name }
    : null,
  path: src.flair__Path__c ?? null,
});

export const mapEmployeeSkillAssociation = (
  src: EmployeeSkillAssociationFragment,
): EmployeeSkillAssociation => ({
  id: src.Id,
  skillId: src.skill.Id,
  isRateable: src.skill.flair__Rateable__c,
  employeeId: src.flair__Employee__c,
  name: src.skill.localizedName,
  baseName: src.skill.Name,
  translations: mapSkillTranslations(src.skill),
  isTop: src.flair__Top__c,
  level: mapSkillLevel(src.flair__Rate__c),
  selfServiceMode: src.skill.flair__Self_Service_Mode__c ?? null,
  monthsExperience: src.flair__Months_Experience__c ?? null,
});

export const mapSkillLevel = (src: number | null): SkillLevel => {
  return isSkillLevel(src) ? src : null;
};
